export default {
    GET_ALL_ITEMS: 0,
    LOGIN_GUID: 'F72AEEC1-D72B-4AE1-8935-F28AD529D6DA',
}


// WEBPACK FOOTER //
// ./src/common/constants/constants.js